module.exports = __webpack_public_path__ + "static/media/YM76_1.334dfa18.jpg";